class EditableTable {
    constructor(name) {
        this.table = document.querySelector(`[data-wp-editable="${name}"]`);
        this.isEdit = false;
        this.isDirty = false;
        this.name = name;
        if (this.table) this.initChangeWatcher();
    }

    initChangeWatcher() {
        this.table.addEventListener('input', e => {
            if (!this.isEdit) return;
            this.isDirty = true;
            window.onbeforeunload = () => true;

            const tr = e.target.closest('tr');
            if (!tr) return;
            const rowId = tr.dataset.rowId;
            if (!rowId) return;

            if (!this.table.querySelector(`input[type="hidden"][data-row-id="${rowId}"]`)) {
                const hidden = document.createElement('input');
                hidden.type = 'hidden';
                hidden.name = `${this.name}[changed_rows][]`;
                hidden.value = rowId;
                hidden.dataset.rowId = rowId;
                this.table.appendChild(hidden);
            }
        });
    }

    toggle() {
        this.isEdit = !this.isEdit;

        // přepnutí view/edit režimu
        this.table.querySelectorAll('[data-role="edit"]').forEach(el =>
            el.classList.toggle('d-none', !this.isEdit)
        );
        this.table.querySelectorAll('[data-role="view"]').forEach(el =>
            el.classList.toggle('d-none', this.isEdit)
        );

        // přepnutí tlačítek
        document.querySelectorAll(`[data-wp-toggle-edit="${this.name}"][data-mode="edit"]`)
            .forEach(btn => btn.classList.toggle('d-none', this.isEdit));

        document.querySelectorAll(`[data-wp-toggle-edit="${this.name}"][data-mode="save"]`)
            .forEach(btn => btn.classList.toggle('d-none', !this.isEdit));

        if (!this.isEdit && !this.isDirty) {
            window.onbeforeunload = null;
        }
    }

    markSaved() {
        this.isDirty = false;
        window.onbeforeunload = null;
        this.table.querySelectorAll('input[type="hidden"][data-row-id]').forEach(el => el.remove());
    }
}

const tableInstances = new Map();

document.addEventListener('click', e => {
    const el = e.target.closest('[data-wp-toggle-edit]');
    if (!el) return;
    const name = el.dataset.wpToggleEdit;
    if (!name) return;

    let table = tableInstances.get(name);
    if (!table) {
        table = new EditableTable(name);
        tableInstances.set(name, table);
    }

    const mode = el.dataset.mode;
    if (mode === 'save') {
        const form = el.form || (el.getAttribute('form') ? document.getElementById(el.getAttribute('form')) : el.closest('form'));
        if (form && form.getAttribute('data-wp-toggle') === 'ajax') {
            // Pokud se ukládá přes AJAX, nebudeme hned toggleovat.
            // Počkáme na 'wp-ajax:success' event.
            return;
        }
    }

    // přepne režim
    table.toggle();
});

document.addEventListener('wp-ajax:success', e => {
    const form = e.target;
    const tablesInForm = form.querySelectorAll('[data-wp-editable]');
    tablesInForm.forEach(tableEl => {
        const name = tableEl.dataset.wpEditable;
        const table = tableInstances.get(name);
        if (table) {
            if (table.isEdit) {
                table.toggle();
            }
            table.markSaved();
        }
    });
});
